export default __webpack_public_path__ + "static/media/mid-b-9.d4e25599.jpg";